<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="page-container form-columns-fit">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ isUpdate ? etapa.nome : $t('nova-etapa') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="onFecharModal()">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="
                                (!integracao && !isUpdate && permissao.create) ||
                                (!integracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input
                                :id="generateId(1)"
                                v-model="etapa.idEtapaErp"
                                ref="idetapaerpInput"
                                placeholder="placeholder-preencha"
                                title="codigo"
                                :maxlength="30"
                                uppercase
                                :required="false"
                                :tooltipLabel="isUpdate ? 'regra-prefixo-GA-edicao' : 'regra-prefixo-GA-criacao'"
                            />
                        </div>
                        <div class="column is-9">
                            <v-input
                                :id="generateId(2)"
                                v-model="etapa.nome"
                                ref="nomeInput"
                                placeholder="placeholder-preencha"
                                title="nome"
                                :maxlength="50"
                                uppercase
                                required
                                :invalid="!etapa.nome"
                            />
                        </div>
                    </div>
                    <div class="columns head is-flex-wrap">
                        <div class="column is-6">
                            <IconsSelect
                                :id="generateId(3)"
                                title="icone"
                                @changeIcon="changeIcon"
                                required
                                ref="iconeInput"
                                msg="msg-campo-obrigatorio"
                                :invalid="invalidIcon"
                                :iconClass="etapa.icone"
                                :icons="icones"
                            ></IconsSelect>
                        </div>
                        <div class="column is-6">
                            <color-picker
                                :id="generateId(4)"
                                title="selecione-uma-cor"
                                :color="etapa.cor"
                                :invalid="!etapa.cor"
                                ref="corInput"
                                @colorpicked="colorpicked"
                            />
                        </div>
                    </div>
                    <div class="columns head is-flex-wrap">
                        <div class="column is-full">
                            <vss-select
                                :id="generateId(5)"
                                ref="situacaoSelect"
                                title="situacao"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="!isUpdate"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EtapaValidation from '@/services/validations/EtapaValidation';
import EtapaServide from '@/services/EtapaService';
import Message from '@/models/Message';
import ColorPicker from '@/components/shared/form/ColorPicker';
import IconsSelect from '@/components/shared/form/IconsSelect';

export default {
    components: {
        IconsSelect,
        ColorPicker,
    },
    props: {
        idFunil: {
            type: Number,
            default: 0,
        },
        etapaSelected: {
            type: Object,
            default: () => {},
        },
        ordem: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('CRM_ETAPA'),
            service: new EtapaServide(this.$http, this.$router),
            validation: new EtapaValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            etapa: {
                id: null,
                idEtapaErp: '',
                idFunil: null,
                nome: '',
                icone: '',
                cor: '#D0CFCF',
                situacao: null,
                ordem: 0,
            },
            icones: [
                { pack: 'fas', class: 'arrows-alt' },
                { pack: 'fas', class: 'compress-arrows-alt' },
                { pack: 'fas', class: 'redo' },
                { pack: 'fas', class: 'question' },
                { pack: 'fas', class: 'exclamation' },
                { pack: 'fas', class: 'ban' },
                { pack: 'fas', class: 'exclamation-triangle' },
                { pack: 'fas', class: 'check-square' },
                { pack: 'fas', class: 'times-circle' },
                { pack: 'fas', class: 'clock' },
                { pack: 'fas', class: 'user-friends' },
                { pack: 'fas', class: 'headset' },
                { pack: 'fas', class: 'phone' },
                { pack: 'fas', class: 'edit' },
                { pack: 'fas', class: 'bell' },
                { pack: 'fas', class: 'paper-plane' },
                { pack: 'fas', class: 'car' },
                { pack: 'fas', class: 'plane' },
                { pack: 'fas', class: 'lock' },
                { pack: 'fas', class: 'unlock' },
            ],
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            isUpdate: false,
            invalidIcon: false,
            isAllowed: false,
            originalIdErp: ''
        };
    },
    created() {
        this.isUpdate = this.etapaSelected != null;

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-funil');

        this.isAllowed =
            (!this.isUpdate && this.permissao.create) || (this.isUpdate && this.permissao.update);

        if (!this.isAllowed) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'funil' },
            });
        } else {
            if (this.isUpdate) {
                this.carregarDados(this.etapaSelected.idEtapa);
            }
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        changeIcon(icon) {
            this.etapa.icone = icon;
        },
        colorpicked(color) {
            this.etapa.cor = color;
        },
        carregarDados(id) {
            this.isLoading = true;

            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.etapa = body.content;
                        this.situacao = this.situacoes[this.etapa.situacao];
                        this.originalIdErp = this.etapa.idEtapaErp;
                    }
                })
                .catch(() => {
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        save() {
            this.etapa.situacao = this.situacao.id;
            this.etapa.idFunil = this.idFunil;
            if (!this.isUpdate) this.etapa.ordem = this.ordem;
            this.invalidIcon = this.etapa.icone == '';

            if (this.validation.validate(this.etapa, this.$refs) && !this.invalidIcon) {
                if(this.isPrefixSovisInIdErpInvalid(this.etapa.idEtapaErp || '', this.originalIdErp)) {
                    const message = 
                        this.isUpdate ? 'nao-permitido-prefixo-ga-alterar' : 'nao-permitido-prefixo-ga-no-campo-codigo';
                    
                    return this.$root.showMessage('alert', message, true);
                }

                let etapaTemp = Object.assign({}, this.etapa);
                etapaTemp = this.mapTosave(etapaTemp);
                this.isSaving = true;

                this.service
                    .save(etapaTemp)
                    .then((value) => {
                        if (value.status == 200) {
                            this.onCloseAndReload();
                        } else {
                            if (this.$t(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(message, { n: this.etapa.idEtapaErp }),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally((_) => {
                        this.isSaving = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
            }
        },
        clearInfo() {
            this.etapa = {
                id: null,
                idEtapaErp: '',
                idFunil: null,
                nome: '',
                icone: '',
                cor: '#D0CFCF',
                situacao: null,
                ordem: 0,
            };
        },
        onCloseAndReload() {
            this.$emit('closeAndReload', true);
            this.clearInfo();
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
            this.clearInfo();
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    height: auto;
    position: relative;

    .form-columns-fit {
        padding-top: 10px;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
